import React, { Component } from 'react';
import privacy from './../privacy-policy.js';

class PrivacyPolicy extends Component {
	componentWillMount() {
		privacy.setPrivacyPolicyPageActive(true);
	}

	componentWillUnmount() {
		privacy.setPrivacyPolicyPageActive(false);
	}

	render() {
		return (
			<div id="privacy-policy" />
		);
	}
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./mobile-core/src/components/privacy-policy.js